// extracted by mini-css-extract-plugin
export default {"date":"d77ASNoyQVE6o4TWrhgA"};